// Plan checks read off the subscription that rides along on GET /auth/me.
//
// The plan name isn't a fixed enum — it has come back as "free", "Free" and
// "Free plan" depending on where it's set — so this matches loosely rather
// than comparing to one exact string. No subscription at all counts as free.

const planNameOf = (user) => {
  const subscription = user?.subscription;
  if (!subscription) return "";

  return String(
    subscription.plan ||
      subscription.planName ||
      subscription.name ||
      subscription.tier ||
      "",
  );
};

/**
 * @param {object} user the record from /auth/me
 * @returns {boolean} true when the account has no paid plan
 */
export const isFreePlan = (user) => {
  // Still loading: don't lock controls on an answer we don't have yet.
  if (!user) return false;

  const name = planNameOf(user).trim().toLowerCase();

  // A subscription object with no readable plan name is treated as paid, so a
  // shape this doesn't recognise can't silently restrict a paying customer.
  if (!name) return !user.subscription;

  return name === "free" || name.startsWith("free");
};
